import { routes } from '@tymely/config';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useOrganizationQuery } from '@tymely/services';

export type PolicyParams = {
    organizationId: string;
    intentId: string;
    versionId?: string;
};

type NavigateToPolicyArgs = {
    organizationId?: number | string;
    intentId?: number | string;
    versionId?: number | string;
};

const usePolicyParams = () => {
    const [queryParams] = useSearchParams();
    const { organizationId, intentId, versionId } = useParams<PolicyParams>();
    const { data: organization } = useOrganizationQuery(Number(organizationId ?? 0), organizationId !== undefined);
    const _navigate = useNavigate();

    const navigate = (params: NavigateToPolicyArgs) => {
        if (!params.organizationId && !organizationId) {
            return;
        }

        const orgId = params.organizationId ?? organizationId;
        let destination = `${routes.graphPolicyEditor}/${orgId}`;

        if (params.intentId) {
            destination = `${destination}/${params.intentId}`;
        }

        if (params.versionId) {
            destination = `${destination}/${params.versionId}`;
        }

        _navigate(`${destination}?${queryParams}`);
    };

    return {
        organizationId: Number(organizationId),
        orgPolicySetId: Number(organization?.org_policy_set_id),
        intentId: Number(intentId),
        versionId: versionId,
        navigate,
    };
};

export default usePolicyParams;
